import { render, staticRenderFns } from "./IndicatorCard.vue?vue&type=template&id=184c2fd6&"
import script from "./IndicatorCard.vue?vue&type=script&lang=js&"
export * from "./IndicatorCard.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorCard.vue?vue&type=style&index=0&id=184c2fd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports